import { ROUTES } from '../constants/routes';
import { getDefaultPostLoginRoute } from '../config/panelMenuAccess';

export function isSafeInternalPath(path) {
  if (typeof path !== 'string') return false;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.includes('\\')) return false;
  return true;
}

export function billingPurchasePath(priceId) {
  const params = new URLSearchParams({ section: 'purchase' });
  if (priceId) params.set('price_id', String(priceId));
  return `${ROUTES.BILLING}?${params.toString()}`;
}

/**
 * مسیر بعد از ورود/ثبت‌نام: query `next` یا `price_id` از سایت، سپس state از ProtectedRoute.
 */
export function resolvePostAuthPath({ location, user, activeOrganization }) {
  const params = new URLSearchParams(location?.search || '');
  const next = params.get('next');
  if (isSafeInternalPath(next)) return next;

  const priceId = params.get('price_id');
  if (priceId) return billingPurchasePath(priceId);

  const from = location?.state?.from;
  if (from?.pathname && isSafeInternalPath(from.pathname)) {
    const full = `${from.pathname}${from.search || ''}`;
    if (from.pathname !== ROUTES.ROOT && from.pathname !== ROUTES.DASHBOARD && from.pathname !== ROUTES.LOGIN) {
      return full;
    }
  }

  return getDefaultPostLoginRoute({ user, activeOrganization });
}
